import { PropsWithChildren, useEffect, useRef } from 'react';

type CardProps = PropsWithChildren;

function OverflowScroll({ children }: CardProps) {
  const tableScrollTopRef = useRef<HTMLDivElement | null>(null);
  const tableScrollTopWidthRef = useRef<HTMLDivElement | null>(null);
  const tableScrollContainerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    // Update scroll width on children change
    const tableScrollTopWidth = tableScrollTopWidthRef.current;
    const tableScrollContainer = tableScrollContainerRef.current;
    if (tableScrollTopWidth && tableScrollContainer) {
      tableScrollTopWidth.style.width = `${tableScrollContainer.scrollWidth}px`;
    }
  }, [children]);

  useEffect(() => {
    // Sync scroll positions
    const tableScrollTop = tableScrollTopRef.current;
    const tableScrollContainer = tableScrollContainerRef.current;
    const tableScrollTopWidth = tableScrollTopWidthRef.current;
    const scrollEventTop = () => {
      if (tableScrollContainer && tableScrollTop) {
        tableScrollContainer.scrollLeft = tableScrollTop.scrollLeft ?? 0;
        if (tableScrollTopWidth) {
          tableScrollTopWidth.style.width = `${tableScrollContainer.scrollWidth}px`;
        }
      }
    };
    const scrollEventContainer = () => {
      if (tableScrollContainer && tableScrollTop) {
        tableScrollTop.scrollLeft = tableScrollContainer.scrollLeft ?? 0;
        if (tableScrollTopWidth) {
          tableScrollTopWidth.style.width = `${tableScrollContainer.scrollWidth}px`;
        }
      }
    };
    if (tableScrollContainer && tableScrollTop) {
      tableScrollTop.addEventListener('scroll', scrollEventTop);
      tableScrollContainer.addEventListener('scroll', scrollEventContainer);
    }

    return () => {
      if (tableScrollContainer && tableScrollTop) {
        tableScrollTop.removeEventListener('scroll', scrollEventTop);
        tableScrollContainer.removeEventListener('scroll', scrollEventContainer);
      }
    };
  }, []);

  return (
    <>
      <div className="mb-2 overflow-x-scroll" ref={tableScrollTopRef}>
        <div className="h-[1px]" ref={tableScrollTopWidthRef} />
      </div>
      <div className="mb-2 overflow-x-scroll" ref={tableScrollContainerRef}>
        {children}
      </div>
    </>
  );
}

export default OverflowScroll;
